module.exports = __webpack_public_path__ + "img/lasource-1.81c0db81.jpg";